import React from "react";
import { Link } from "react-router-dom";
import { MessageCircle, ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { useLanguage } from "../i18n/LanguageContext";
import { usePublicContent } from "../i18n/PublicContentContext";

export default function CTASection({ title, subtitle, waMessage }) {
  const { t } = useLanguage();
  const { waLink } = usePublicContent();
  const _title = title || t.cta.homeTitle;
  const _subtitle = subtitle || t.cta.homeSubtitle;

  return (
    <section className="relative py-20 lg:py-28 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-[#F4F6FA] to-white" />
      <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-[#E84B1C]/15 blur-3xl" />
      <div className="absolute -bottom-24 -left-24 w-96 h-96 rounded-full bg-[#E84B1C]/10 blur-3xl" />
      <div className="relative max-w-4xl mx-auto px-5 lg:px-8 text-center">
        <Reveal>
          <h2 className="font-head text-3xl md:text-5xl font-bold text-[#12284B] leading-tight text-balance">
            {_title}
          </h2>
          <p className="mt-5 text-black/70 text-lg max-w-2xl mx-auto">{_subtitle}</p>
          <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href={waLink(waMessage)}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 bg-[#E84B1C] hover:bg-[#F0673E] text-white font-head font-semibold px-8 py-4 rounded-full transition-all duration-300 hover:scale-105 glow-orange"
            >
              <MessageCircle size={20} /> {t.cta.whatsappBtn}
            </a>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 border border-[#12284B]/25 hover:border-[#E84B1C] text-[#12284B] font-head font-semibold px-8 py-4 rounded-full transition-all duration-300 hover:bg-[#12284B]/5"
            >
              {t.cta.freeConsult} <ArrowRight size={18} />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
